// components/DeliveryAddress/DeliveryAddress.jsx
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory, useLocation, Redirect } from 'react-router-dom';
import { getTranslate } from 'react-localize-redux';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { Toast } from 'react-bootstrap';

// Components
import InPlaceLoader from '../InPlaceLoader';

// Hooks
import { useShipping, useAccountBalance, useEvents, useCheckout } from './hooks';

// Actions
import { cart_date, cart_time_index, order_address_setter, order_shipping_setter } from '../../actions/cartActions';
import { set_pay_type_action } from '../../actions/setPayTypeAction';
import DiscountSection from './DiscountSection';
import ShippingMethods from './ShippingMethods';
import PaymentTypeSection from './PaymentTypeSection';
import EventsModal from './EventsModal';
import ActionButtons from './ActionButtons';
import { successAction } from '../../actions/successAction';
import { errorAction } from '../../actions/request_error';
import AddressSection from './AddressSection';
import useToast from '../login/hook/useToast';
import ConfirmationModal from './ConfirmationModal';

const DeliveryAddress = ({ nextStep }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const translate = useSelector((state) => getTranslate(state.localize));
  const class_toast = 'bg-success';
  const class_toast_error = 'bg-danger';

  // Redux state
  const cart = useSelector((state) => state.cart);
  const user = useSelector((state) => state.user);
  const cartReport = useSelector((state) => state.cart.cart_report);
  const orderAddress = useSelector((state) => state.cart.order_address);
  const orderShipping = useSelector((state) => state.cart.order_shipping);
  const priceShipping = useSelector((state) => state.cart.price_shipping);
  const timeIndex = useSelector((state) => state.cart.time_index);
  const date = useSelector((state) => state.cart.date);
  const gold = useSelector((state) => state.gold_price);

  // اضافه کردن selector های مورد نیاز برای modal
  const depositPrice = useSelector((state) => state.deposit_price);
  const payType = useSelector((state) => state.pay_type);
  const credit = useSelector((state) => state.cart.cart_credit);
  const discount = useSelector((state) => state.discount);

  // Local state
  const [showShippingError, setShowShippingError] = useState(false);
  const [showAddressError, setShowAddressError] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [notAccept, setNotAccept] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [modalCheckMethod, setModalCheckMethod] = useState(false);
  const [openDiscount, setOpenDiscount] = useState(false); // اضافه کردن state برای تخفیف
  const { toasts, showSuccessToast, showErrorToast, hideSuccessToast, hideErrorToast } = useToast();

  // Custom hooks
  const { shippingMethods, shippingTimes, shippingPrice, shippingInsurance, loading: shippingLoading, calculateShippingPrice } = useShipping();

  const { balance } = useAccountBalance(cartReport.total_price, gold, user['is_teammate']);

  const { eventModal, eventModalText, closeEventModal } = useEvents();

  const { loading: checkoutLoading, confirmed, performFinalCheck, handlePreOrder } = useCheckout();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  // Effects
  useEffect(() => {
    if (orderShipping === '2') {
      dispatch(order_shipping_setter(null));
    }
  }, [orderShipping]);
  useEffect(() => {
    if (location.state?.referrer === '/confirm') {
      dispatch(successAction('روش ارسال را انتخاب کنید و اطلاعات را چک کنید'));
      showSuccessToast('روش ارسال را انتخاب کنید و اطلاعات را چک کنید');
    }
  }, [location.state, dispatch]);
  useEffect(() => {
    dispatch(order_shipping_setter(null));
  }, [orderAddress]);

  useEffect(() => {
    // const isEnabled = !!orderShipping && priceShipping !== null && orderAddress;
    // setDisabled(!isEnabled);
  }, [orderShipping, priceShipping, orderAddress]);

  useEffect(() => {
    if (orderShipping && orderAddress) {
      calculateShippingPrice(orderShipping, orderAddress, cartReport.total_price);
    }
  }, [orderShipping, orderAddress, cartReport.total_price, calculateShippingPrice]);

  // Handlers
  const handleAddressSelect = (address) => {
    setSelectedAddress(address);
  };

  const handleInPersonPickup = () => {
    dispatch(order_address_setter(1));
    dispatch(order_shipping_setter('3'));
    dispatch(set_pay_type_action('cashe'));
    nextStep();
  };

  const handleCityChange = (city) => {
    // Additional logic if needed
  };

  const handleShippingSelect = (methodId) => {
    if (eventModal && eventModalText) {
      setModalCheckMethod(true);
    }
  };

  const handleShippingMethodConfirm = (methodId) => {
    setModalCheckMethod(false);
    // Additional shipping method confirmation logic
  };

  const setCartDate = (index, date) => {
    dispatch(cart_date(date));
    dispatch(cart_time_index(index));
  };
  useEffect(() => {
    if (showAddressError && orderAddress) {
      setShowAddressError(false);
    }
  }, [orderAddress]);

  useEffect(() => {
    if (showShippingError && orderShipping) {
      setShowShippingError(false);
    }
  }, [orderShipping]);

  const handleContinueClick = () => {
    console.log({ orderShipping });
    if (!orderAddress) {
      showErrorToast(translate('address_empty'));
      setShowAddressError(true);
      return;
    } else if (!orderShipping) {
      const errorMsg = 'روش ارسال را انتخاب کنید';

      // نمایش ارور در کامپوننت ShippingMethods
      setShowShippingError(true);
      showErrorToast(errorMsg);
    } else {
      setShowModal(true);
    }
  };

  const handleFinalConfirm = async () => {
    setShowModal(false);
    const result = await performFinalCheck(orderAddress, orderShipping);

    if (!result.success) {
      // Error handling is done in the hook
    }
  };

  const handleNotAccept = () => {
    setShowModal(false);
    setNotAccept(true);
  };

  // Handler برای کلیک روی کد تخفیف
  const handleDiscountClick = () => {
    setShowModal(false);
    setOpenDiscount(true);

    // اسکرول به بخش تخفیف
    const appBarHeight = document.querySelector('.appbar-sticky')?.offsetHeight;
    const section = document.getElementById('card-discount');

    if (section) {
      const sectionPosition = section.getBoundingClientRect().top + window.pageYOffset;
      let offsetPosition = '';
      if (appBarHeight) {
        offsetPosition = sectionPosition - appBarHeight;
      } else {
        offsetPosition = sectionPosition;
      }

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    }
  };

  // Calculate final test value for redirect
  const calculateTestValue = () => {
    const { pool, gram, creditor } = balance;
    const beyane = balance.beyane;

    if (user['is_teammate'] === 1) {
      const gramPrice = gram * gold;
      if (pool > 0 && gram <= 0) {
        return pool >= beyane;
      }
      if (pool <= 0 && gram > 0) {
        return gramPrice >= beyane;
      }
      if (pool > 0 && gram > 0) {
        return pool + gramPrice >= beyane;
      }
    } else {
      let adjustedCreditor = creditor;
      if (user['is_teammate'] !== 1 && adjustedCreditor) {
        adjustedCreditor = adjustedCreditor + parseFloat(shippingPrice + '0');
      }

      if (adjustedCreditor === 0) {
        return shippingPrice !== null
          ? cartReport.total_price + parseFloat(shippingPrice + '0') - balance.mandeHesabPrice / 10
          : cartReport.total_price - balance.mandeHesabPrice / 10;
      } else {
        return -1;
      }
    }
    return 0;
  };

  // Redirects
  if (confirmed) {
    // const testValue = calculateTestValue();
    // return (
    //   <Redirect
    //     to={{
    //       pathname: '/confirm',
    //       state: { mandeHesabPrice: testValue },
    //     }}
    //   />
    // );
    nextStep();
  }

  if (notAccept) {
    return <Redirect to='/cart' />;
  }

  const preOrder = location.state?.preOrder;
  const showWaitingLoader = checkoutLoading ? 'd-flex' : 'd-none';

  return (
    <>
      <div className='rtl' style={{ backgroundColor: 'white' }}>
        {/* Loading Overlay */}
        <InPlaceLoader className={showWaitingLoader} text={translate('waiting_for_progress')} />

        {/* Address Section */}
        <AddressSection onAddressSelect={handleAddressSelect} onCityChange={handleCityChange} onInPersonPickup={handleInPersonPickup} showError={showAddressError} />

        {/* Discount Section */}
        <DiscountSection disabled={!orderAddress} openDiscount={openDiscount} setOpenDiscount={setOpenDiscount} />

        {/* Shipping Methods */}
        <ShippingMethods
          shippingMethods={shippingMethods}
          shippingInsurance={shippingInsurance}
          shippingPrice={shippingPrice}
          selectedShipping={orderShipping}
          onShippingSelect={handleShippingSelect}
          loading={shippingLoading}
          showError={showShippingError}
        />

        {/* Events Display */}
        {eventModalText && (
          <div className='c-font-sm mb-3 mt-4 ticket' style={{ color: '#c82333' }}>
            <CKEditor
              disabled
              editor={ClassicEditor}
              data={eventModalText}
              config={{
                language: 'fa',
                toolbar: [],
              }}
            />
          </div>
        )}

        {/* Action Buttons */}
        <ActionButtons onContinueClick={handleContinueClick} disabled={disabled} preOrder={preOrder} />

        {/* Confirmation Modal - استفاده از کامپوننت جدید */}
        <ConfirmationModal
          show={showModal}
          onHide={() => setShowModal(false)}
          onConfirm={handleFinalConfirm}
          balance={balance}
          shippingPrice={shippingPrice}
          selectedShipping={orderShipping}
          cartReport={cartReport}
          payType={payType}
          depositPrice={depositPrice}
          credit={credit}
          discount={discount}
          onDiscountClick={handleDiscountClick}
        />

        {/* Events Modal for Shipping Method */}
        <EventsModal show={modalCheckMethod} onHide={() => setModalCheckMethod(false)} onContinue={() => handleShippingMethodConfirm(orderShipping)} eventText={eventModalText} />
      </div>

      {/* Toast Messages */}
      <Toast
        className={'rtl position-fixed color-white z-index-top ' + class_toast}
        style={{
          position: 'fixed',
          top: '20px',
          left: '50%',
          transform: 'translateX(-50%)',
          zIndex: 999999999999,
          borderRadius: '12px',
          border: 'none',
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          minWidth: '350px',
          backgroundColor: '#28a745',
          cursor: 'pointer',
        }}
        show={toasts.success.show}
        onClose={hideSuccessToast}
        onClick={hideSuccessToast}
        autohide={true}
        delay={4000}
      >
        <Toast.Body
          style={{
            padding: '12px 20px',
            fontSize: '12px',
            textAlign: 'center',
            color: 'white',
            fontWeight: '500',
          }}
        >
          {toasts.success.message}
        </Toast.Body>
      </Toast>

      <Toast
        className={'rtl position-fixed color-white z-index-top ' + class_toast_error}
        style={{
          position: 'fixed',
          top: '20px',
          left: '50%',
          transform: 'translateX(-50%)',
          zIndex: 999999999999,
          borderRadius: '12px',
          border: 'none',
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          minWidth: '350px',
          backgroundColor: '#dc3545',
        }}
        show={toasts.error.show}
        onClose={hideErrorToast}
        autohide={true}
        delay={4000}
      >
        <Toast.Body
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '12px 20px',
            fontSize: '11px',
            textAlign: 'center',
            color: 'white',
            fontWeight: '500',
          }}
        >
          <div>{toasts.error.message}</div>
          <button
            onClick={hideErrorToast}
            style={{
              backgroundColor: 'transparent',
              border: 'none',
              color: 'white',
              padding: '4px 5px',
              fontSize: '11px',
              cursor: 'pointer',
              fontWeight: '500',
            }}
          >
            بستن
          </button>
        </Toast.Body>
      </Toast>
    </>
  );
};

export default DeliveryAddress;
